package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class ForgotPasswordRequest(
    @SerialName("email") var email: String? = null
)